import type {
  CustomerEnquetesResponses as ApiResponses,
  CustomerEnquetesParams as ApiParams,
} from '@/types/externals/obbsApi';

export const useCustomerEnquete = () => {
  const customerEnquete = useState<ApiResponses.CustomerEnquete | null>(
    'customerEnquete',
    () => null
  );

  const fetchCustomerEnquete = async (serialNumber: string): Promise<void> => {
    const url: string = `/customer-enquetes/${serialNumber}`;
    const { data, error } = await useApiFetch<ApiResponses.CustomerEnquete>(url);

    if (error.value) {
      throw createError({
        statusCode: error.value.status,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }

    customerEnquete.value = data.value;
  };

  const getCustomerEnquete = (): ApiResponses.CustomerEnquete | null => {
    return customerEnquete.value;
  };

  const getCustomerEnquetes = async (): Promise<ApiResponses.CustomerEnquete[]> => {
    const url: string = `/customer-enquetes?isInProgress=true`;
    const { data, error } = await useApiFetch<ApiResponses.CustomerEnquete[]>(url);

    if (error.value) {
      throw createError({
        statusCode: error.value.status,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }

    return data.value;
  };

  const submitCustomerEnquete = async (params: ApiParams.PostParams): Promise<void> => {
    const url: string = '/customer-enquetes';
    const { error } = await useApiFetch<void>(url, {
      method: 'POST',
      body: params,
    });

    if (error.value) {
      throw createError({
        statusCode: error.value.status,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }
  };

  return {
    getCustomerEnquete,
    getCustomerEnquetes,
    fetchCustomerEnquete,
    submitCustomerEnquete,
  };
};
